
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconComponent from '@/components/IconComponent.vue';

@Component<ActionTypeComponent>({ components: { IconComponent } })
export default class ActionTypeComponent extends Vue {
  @Prop()
  readonly topic?: string;
}
